import React from "react";
import "./styles.css";
import { IndianFlagWithStars } from "../../../Assets/images/svgs";

const RegPlate = ({ reg = "XX XX XX XXXX" }) => {
  return (
    <div className="registration-plate-ui">
      <div className="country-and-icon">
        <IndianFlagWithStars />
        <p className="flag-text">IND</p>
      </div>
      <div className="registration-number">
        <p>{reg}</p>
      </div>
    </div>
  )
}

export default RegPlate
